import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var Message = styled.p.withConfig({
  displayName: "ui-kit-Message",
  componentId: "ui-kit-a9aw03"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  margin: 4px 0 0 0;\n  padding-left: 16px;\n  line-height: 16px;\n  min-height: 16px;\n  font-size: 12px;\n  letter-spacing: 0.2px;\n\n  &.error {\n    color: ", ";\n  }\n\n  &.disabled {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  margin: 4px 0 0 0;\n  padding-left: 16px;\n  line-height: 16px;\n  min-height: 16px;\n  font-size: 12px;\n  letter-spacing: 0.2px;\n\n  &.error {\n    color: ", ";\n  }\n\n  &.disabled {\n    color: ", ";\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.palette.label.secondary;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.negative;
}, function (_a) {
  var theme = _a.theme;
  return theme.palette.label.inactive;
});
var templateObject_1;